import { render, staticRenderFns } from "./BdThreadAgent.vue?vue&type=template&id=15aa8402&"
import script from "./BdThreadAgent.vue?vue&type=script&lang=js&"
export * from "./BdThreadAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports